import Header from '../components/Header';
import Careers from '../components/Careers';
import Footer from '../components/Footer';
import WhatsAppFloat from '../components/WhatsAppFloat';

const CareersPage = () => {
  return (
    <>
      <Header />
      <div style={{marginTop: '64px'}}>
        <Careers />
      </div>
      <Footer />
      <WhatsAppFloat />
    </>
  );
};

export default CareersPage;